import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { CommonConstants } from '../constants/common-constants';
import { AuthService } from './auth.service';
import { CustomToastrService } from './custom-toastr-service';

@Injectable()
export class BaseHttpService implements HttpInterceptor {
	readonly commonConstants = CommonConstants;

	constructor(private authService: AuthService, private customToastrService: CustomToastrService) { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		// Check if the request needs authentication
		if (this.onCheckURLMatches(request)) {
			return this.authService.getToken().pipe(
				switchMap((token) => {
					if (token) {
						request = request.clone({
							setHeaders: {
								Authorization: `Bearer ${token}`,
								// Pragma: 'no-cache',
								// 'Cache-Control': 'no-cache, no-store, must-revalidate',
								// 'Referrer-Policy': 'no-referrer',
								// 'X-XSS-Protection': '1; mode=block',
								// 'X-Content-Type-Options': 'nosniff',
								// 'X-Frame-Options': 'DENY',
								// 'X-Permitted-Cross-Domain-Policies': 'none',
								// 'Permissions-Policy': 'sync-xhr=*',
								// 'Content-Security-Policy': "default-src 'self'",
								// 'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload',
							},
						});
					}

					return next.handle(request).pipe(
						catchError((error: HttpErrorResponse) => {
							//  Handle CORS or Network Errors
							if (error.status === 0 && error.error instanceof ProgressEvent) {
								this.customToastrService.error(this.commonConstants.crosOrNetworkError);
								return throwError(() => new Error(this.commonConstants.crosOrNetworkError));
							}

							// 🛑 Skip alert for "No Alerts found." responses
							const alertResponse = error.error?.arrowxl_alert_response?.status;
							if (
								alertResponse?.statuscode === '400' &&
								alertResponse?.message === 'No Alerts found.'
							) {
								// just return the error silently, no toast/alert
								return throwError(() => error);
							}

							//  Handle other errors
							this.errorHandler(error);
							return throwError(() => error);
						})
					);
				})
			);
		}

		// If URL doesn't need authentication
		return next.handle(request).pipe(
			catchError((error: HttpErrorResponse) => {
				//  Handle CORS or Network Errors
				if (error.status === 0 && error.error instanceof ProgressEvent) {
					this.customToastrService.error(this.commonConstants.crosOrNetworkError);
					return throwError(() => new Error(this.commonConstants.crosOrNetworkError));
				}

				// Skip alert for "No Alerts found." responses
				const alertResponse = error.error?.arrowxl_alert_response?.status;
				if (
					alertResponse?.statuscode === '400' &&
					alertResponse?.message === 'No Alerts found.'
				) {
					// just return the error silently, no toast/alert
					return throwError(() => error);
				}

				this.errorHandler(error);
				return throwError(() => error);
			})
		);
	}

	onCheckURLMatches(request: any): any {
		if (!request.url.match(/authenticate/g)) {
			return true;
		}
		return false;
	}

	errorHandler(error: any): any {
		switch (error.status) {
			case 400:
				this.customToastrService.error(error.error.error);
				break;
			case 401:
				this.customToastrService.error(CommonConstants.sessionErrorText);
				break;
			case 403:
				this.customToastrService.error(CommonConstants.permissionErrorText);
				break;
			case 404:
				this.customToastrService.error(CommonConstants.serverErrorText);
				break;
		}
	}
}
